
import BaseInput from "@/components/base/BaseInput.vue";
import BaseSection from "@/components/base/BaseSection.vue";
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import { useBookingStore } from "@/store/booking";
import { defineComponent } from "vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { reactive, watch } from "vue";

	export default defineComponent({
		components: {
        BaseSection,
        BaseInput,
        BaseCheckbox,
		},	
      setup() {
          const bookingStore = useBookingStore();
					
          const state = reactive({
              customerEmail: bookingStore.getBooking.addressInformation.email,
              sendConfirmation: bookingStore.getBooking.sendConfirmation,
              sendConfirmationCopy: bookingStore.getBooking.sendConfirmationCopy
          });

          const rules = {
              customerEmail : { required },
              sendConfirmation : {},
              sendConfirmationCopy: {},
          }

          const v$ = useVuelidate(rules, state);   

          watch(
              (state),
              () => {
                  const stateIsValid = Object.values(state).every(x => x !== null && x !== '');
                  
                  if (stateIsValid) {
                      
										bookingStore.setCustomerEmail(state.customerEmail);
										bookingStore.setSendConfirmation(state.sendConfirmation);
										bookingStore.setSendConfirmationCopy(state.sendConfirmationCopy);
                      // save email
                  }
              }
          );
          
          return { v$ };
      }
	});
